export function buildContractQueryString(searchParams: URLSearchParams, overrides?: Record<string, string>) {
  const params = new URLSearchParams();
  const cid = searchParams.get('cid');
  const source = searchParams.get('source');
  const org = searchParams.get('org');
  const intMod = searchParams.get('int_mod');

  if (cid) params.set('cid', cid);
  if (source) params.set('source', source);
  if (org) params.set('org', org);
  if (intMod) params.set('int_mod', intMod);

  if (overrides) {
    Object.entries(overrides).forEach(([key, value]) => {
      params.set(key, value);
    });
  }

  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function contractPath(path: string, searchParams: URLSearchParams) {
  return `${path}${buildContractQueryString(searchParams)}`;
}

/** @deprecated Use `buildContractQueryString` — alias mantido para imports legados. */
export const buildContractSearchParams = buildContractQueryString;
